import axios from 'axios'
import http from '@/services/http'
import { setRouteTaskToList, unsetRouteTaskFromList } from '@/utils/sharedOrdersMutations'

let cancelRegionOrdersSrc = null
let cancelExpressAnalysisSrc = null
let cancelShiftStatsSrc = null

export default {
  namespaced: true,
  state: {
    regionOrdersLoading: false,
    ordersStatsLoading: false,
    regionOrders: {
      data: [],
      count: 0,
      /**
       * доступные поля сортировки
       */
      sort: [],
      /**
       * Доступные статусы для фильтрации
       */
      statuses: []
    },
    regionOrdersByStatuses: null,
    regionOrderPayments: null,
    regionOrdersFilters: {
      limit: 200,
      offset: 0,
      search: '',
      sort: '',
      statuses: []
    },

  },
  mutations: {
    SET_REGION_ORDERS_LOADING(state, regionOrdersLoading) {
      state.regionOrdersLoading = regionOrdersLoading
    },
    SET_ORDERS_STATS_LOADING(state, ordersStatsLoading) {
      state.ordersStatsLoading = ordersStatsLoading
    },
    SET_REGION_ORDERS(state, regionOrders) {
      state.regionOrders = regionOrders
    },
    SET_REGION_ORDERS_BY_STATUSES(state, regionOrdersByStatuses) {
      state.regionOrdersByStatuses = regionOrdersByStatuses
    },
    SET_REGION_ORDERS_PAYMENTS(state, regionOrderPayments) {
      state.regionOrderPayments = regionOrderPayments
    },
    SET_REGION_ORDERS_FILTERS(state, regionOrdersFilters) {
      state.regionOrdersFilters = regionOrdersFilters
    },
    
    /**
     * SET_ROUTE_TASK и UNSET_ROUTE_TASK 
     * вызывается из модуля routeTasks
     */
    SET_ROUTE_TASK(state, routeTaskData) {
      setRouteTaskToList(state.regionOrders.data, { ...routeTaskData, idField: 'route_task_id' })
    },
    UNSET_ROUTE_TASK(state, orderIds) {
      unsetRouteTaskFromList(state.regionOrders.data, orderIds)
    }
  },
  actions: {
    async getRegionOrders({ state, rootState, commit, rootGetters }) {
      try {
        commit('SET_REGION_ORDERS_LOADING', true)
        const sendedFilters = { ...state.regionOrdersFilters }
        sendedFilters.statuses = sendedFilters.statuses.join(',')
        if (!sendedFilters.statuses) {
          delete sendedFilters.statuses
        }
        if (!sendedFilters.sort) {
          delete sendedFilters.sort
        }
        if (rootGetters['manufactures/areasIds']) {
          sendedFilters.area_ids = rootGetters['manufactures/areasIds']
        }
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        cancelRegionOrdersSrc = source
        const selectedCity = rootState.manufactures.selectedCity
        const res = await http.get(`cities/${selectedCity.city_id}/main`, {
          v3: true,
          cancelToken: source.token,
          params: sendedFilters
        })
        if (sendedFilters.offset !== 0) {
          res.orders.data = [ ...state.regionOrders.data, ...res.orders.data]
        }
        commit('SET_REGION_ORDERS', res.orders)
        commit('SET_REGION_ORDERS_BY_STATUSES', res.orders_by_statuses)
        commit('SET_REGION_ORDERS_PAYMENTS', res.revenue)
      } finally {
        commit('SET_REGION_ORDERS_LOADING', false)
      }
    },
    cancelRegionOrders() {
      if (cancelRegionOrdersSrc) {
        cancelRegionOrdersSrc.cancel()
      }
    },
    async getExpressAnalysys({ rootState, rootGetters }, manualCity) {
      const sendedFilters = {}
      /**
       * Если передается город в функцию, то
       * пока не устанавливаем территории, поскольку
       * предполагается установка всех территорий города
       * и по умолчанию можно не указывать
       */
      if (!manualCity && rootGetters['manufactures/areasIds']) {
        sendedFilters.area_ids = rootGetters['manufactures/areasIds']
      }
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      cancelExpressAnalysisSrc = source
      /**
       * метод запускается в компоненте orders-statistics,
       * где нет отслеживания выбранного города
       */
      const cityId = manualCity ? manualCity.city_id :
        rootState.manufactures.selectedCity ? 
        rootState.manufactures.selectedCity.id : 
        rootState.manufactures.selectedManufacture.city_id
      const res = await http.get(`cities/${cityId}/orders/express`, {
        cancelToken: source.token,
        params: sendedFilters
      })
      return res
    },
    cancelExpressAnalysis() {
      if (cancelExpressAnalysisSrc) {
        cancelExpressAnalysisSrc.cancel()
      }
    },
    async getShiftStats({ rootState, commit, rootGetters }) {
      const sendedFilters = {}
      if (rootGetters['manufactures/areasIds']) {
        sendedFilters.area_ids = rootGetters['manufactures/areasIds']
      }
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      cancelShiftStatsSrc = source
      commit('SET_ORDERS_STATS_LOADING', true)
      try {
        const selectedCity = rootState.manufactures.selectedCity
        const res = await http.get(`cities/${selectedCity.city_id}/shifts/stats`, {
          cancelToken: source.token,
          params: sendedFilters
        })
        return res
      } finally {
        commit('SET_ORDERS_STATS_LOADING', false)
      }
      
    },
    cancelShiftStats() {
      if (cancelShiftStatsSrc) {
        cancelShiftStatsSrc.cancel()
      }
    }
  }
}